<script>
import { simpleComputed } from '@state/helpers'

export default {
	components: {},
	props: {
		time : {
			type: Number,
			required: true,
		},
		variant : {
			type: String,
      required: true,
      // default: () => ('info'),			
		}
	},
	data() {
		return {
		}
	},
	computed : {
		...simpleComputed,
	},
	mounted() {
		setTimeout(() => {
			this.deleteMessage(this.time);
		}, 2000);
	},
	methods : {
	},

}
</script>

<template>
	<b-alert  show :variant="variant"><slot></slot></b-alert>
</template>
